export default "__VITE_ASSET__0837306e__"